import React from 'react';

import PropTypes from 'prop-types';

import { emptyObject } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

import CreditCardContextProvider from './credit-card-context-provider';
import CreditCardCvv from './credit-card-cvv';
import CreditCardExpiration from './credit-card-expiration';
import CreditCardName from './credit-card-name';
import CreditCardNumber from './credit-card-number';

import style from './style.module.less';

const CreditCard = ({ creditCardInfo, onChange = noop, onBlur = noop, errors = emptyObject, disabled = false, showAllErrors = false }) => {
  return (
    <CreditCardContextProvider
      creditCardInfo={creditCardInfo}
      disabled={disabled}
      errors={errors}
      onBlur={onBlur}
      onChange={onChange}
      showAllErrors={showAllErrors}
    >
      <form className={style.container}>
        <CreditCardNumber />
        <div className={style['expiration-row']}>
          <CreditCardExpiration />
          <CreditCardCvv />
        </div>
        <CreditCardName />
      </form>
    </CreditCardContextProvider>
  );
};

CreditCard.propTypes = {
  creditCardInfo: PropTypes.shape({
    cardName: PropTypes.string,
    cardProvider: PropTypes.string,
    cardNumber: PropTypes.string,
    expiry: PropTypes.string,
    cvv: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func,
  errors: PropTypes.shape({
    cardName: PropTypes.object,
    cardProvider: PropTypes.object,
    cardNumber: PropTypes.object,
    expiry: PropTypes.object,
    cvv: PropTypes.object,
  }),
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  showAllErrors: PropTypes.bool,
};

export default CreditCard;
